import { SHIPMENT_COREENTITY_VALUES } from '@/modules/shipments-module/old/constants/shipmentCoreEntities'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { groupBy } from 'lodash'

export default {
    methods: {
        isSelectedOptionExternal(selectedSideBarOption) {
            return !!selectedSideBarOption.includes('external')
        },
        generateElementsByEntity(samples, portions, subportions, casId, samId) {
            let elements = []
            if (samples && samples.length) {
                const samplesMap = samples.map(sample => {
                    return {
                        id: sample.samId,
                        caseId: sample.caseStudy ? sample.caseStudy.casId : casId,
                        label: sample.samLabel,
                        entity: SHIPMENT_COREENTITY_VALUES.SAMPLE,
                        icon: 'fal fa-prescription-bottle main'
                    }
                })
                elements = elements.concat(samplesMap)
            }
            if (portions && portions.length) {
                const portionsMap = portions.map(portion => {
                    return {
                        id: portion.id ? portion.id : portion.porId,
                        sampleId: portion.samId ? portion.samId : samId,
                        label: portion.label,
                        entity: SHIPMENT_COREENTITY_VALUES.PORTION,
                        icon: PORTION_TYPES[portion.portionTypeEnum].icon
                    }
                })
                elements = elements.concat(portionsMap)
            }
            if (subportions && subportions.length) {
                const subportionsMap = subportions.map(subportion => {
                    return {
                        id: subportion.supId ? subportion.supId : subportion.subportionId,
                        portionId: subportion.porId ? subportion.porId : subportion.portionId,
                        sampleId: subportion.samId ? subportion.samId : subportion.sampleId,
                        label: subportion.subportionLabel ? subportion.subportionLabel : subportion.label,
                        entity: SHIPMENT_COREENTITY_VALUES.SUBPORTION,
                        icon: 'fal icon-porta main'
                    }
                })
                elements = elements.concat(subportionsMap)
            }
            return elements
        },
        generateElements(selectedElements) {
            let elements = []
            const sampleElements = selectedElements.filter(selectedElement => selectedElement.coreEntity === SHIPMENT_COREENTITY_VALUES.SAMPLE.code)
            const portionElements = selectedElements.filter(selectedElement => selectedElement.coreEntity === SHIPMENT_COREENTITY_VALUES.PORTION.code)
            const subportionElements = selectedElements.filter(selectedElement => selectedElement.coreEntity === SHIPMENT_COREENTITY_VALUES.SUBPORTION.code)
            if (sampleElements && sampleElements.length) {
                const samplesMap = sampleElements.map(sampleElement => {
                    return {
                        entityShipmentRequestId: sampleElement.id,
                        pathologist: sampleElement.pathologist,
                        sampleId: sampleElement.sample.id,
                        caseId: sampleElement.caseStudy.id,
                        label: sampleElement.entityLabel,
                        caseLabel: sampleElement.caseStudy.label,
                        entity: SHIPMENT_COREENTITY_VALUES.SAMPLE,
                        icon: 'fal fa-prescription-bottle main'
                    }
                })
                elements = elements.concat(samplesMap)
            }
            if (portionElements && portionElements.length) {
                const portionsMap = portionElements.map(portionElement => {
                    return {
                        entityShipmentRequestId: portionElement.id,
                        portionId: portionElement.portion.id,
                        caseId: portionElement.caseStudy.id,
                        sampleId: portionElement.sample.id,
                        label: portionElement.entityLabel,
                        caseLabel: portionElement.caseStudy.label,
                        entity: SHIPMENT_COREENTITY_VALUES.PORTION,
                        icon: PORTION_TYPES[portionElement.portion.portionTypeEnum].icon
                    }
                })
                elements = elements.concat(portionsMap)
            }
            if (subportionElements && subportionElements.length) {
                const subportionsMap = subportionElements.map(subportionElement => {
                    return {
                        entityShipmentRequestId: subportionElement.id,
                        subportionId: subportionElement.subportion.id,
                        caseId: subportionElement.caseStudy.id,
                        portionId: subportionElement.portion.id,
                        sampleId: subportionElement.sample.id,
                        label: subportionElement.entityLabel,
                        caseLabel: subportionElement.caseStudy.label,
                        entity: SHIPMENT_COREENTITY_VALUES.SUBPORTION,
                        icon: 'fal icon-porta main'
                    }
                })
                elements = elements.concat(subportionsMap)
            }
            return Object.values(groupBy(elements, 'caseId')).map(caseEntities => {
                const caseId = caseEntities[0].caseId
                const caseLabel = caseEntities[0].caseLabel
                const pathologist = caseEntities[0].pathologist
                return {
                    caseLabel: caseLabel,
                    caseId: caseId,
                    pathologist: pathologist,
                    entities: caseEntities
                }
            })
        }
    }
}
